export const asyncForEach = async <T>(items: Array<T>, cb: (item: T, i: number) => Promise<any>) => {

    for (let i = 0; i < items.length; i++) {
        await cb(items[i], i);
    }
    return Promise.resolve();
};



// WEBPACK FOOTER //
// ./src/core/util/async-for-each.ts